import { API } from 'config';

function AdminService($http, $resource) {

  'ngInject';

  const SubscriptionResource = $resource(API.ADMIN.SUBSCRIPTIONS, { subscription_id: '@id' }, {
    get: {
      method: 'GET',
      isArray: true,
    },
    create: {
      method: 'POST',
    },
    update: {
      method: 'PUT',
    },
    delete: {
      method: 'DELETE',
    },
  });

  return {
    createSubscription: (companyId, subscription) =>
      SubscriptionResource.create({ companyId }, subscription).$promise,

    updateSubscription: (companyId, subscriptionId, subscription) =>
        SubscriptionResource.update({ companyId, subscriptionId }, subscription).$promise,

    deleteSubscription: (companyId, subscriptionId) =>
        SubscriptionResource.delete({ companyId, subscriptionId }).$promise,

    getSubscriptions: (companyId) =>
      SubscriptionResource.get({ companyId }).$promise,
  };
}

export default AdminService;



// WEBPACK FOOTER //
// ./src/services/Admin.js